import { render } from "./StoreTarget.vue?vue&type=template&id=04b4c6fc"
import script from "./StoreTarget.vue?vue&type=script&lang=js"
export * from "./StoreTarget.vue?vue&type=script&lang=js"

import exportComponent from "/Users/avinduhewa/Documents/Projects/bokaklip/payl-firebase/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__